import { render, staticRenderFns } from "./0.vue?vue&type=template&id=4fe7553c&scoped=true&"
var script = {}
import style0 from "./0.vue?vue&type=style&index=0&id=4fe7553c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7553c",
  null
  
)

export default component.exports